/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsOverviewDataSchema = z.object({
	summary: z.object({
		totalCampaigns: z.number(),
		totalCandidates: z.number(),
		totalHires: z.number(),
		totalBudget: z.number(),
		avgBudgetPerCandidate: z.number().nullable(),
		avgPricePerHire: z.number().nullable(),
		totalViews: z.number(),
	}),
	breakdown: z.object({
		data: z.array(
			z.object({
				id: z.string(),
				title: z.string(),
				status: z.union([
					z.literal('draft'),
					z.literal('review'),
					z.literal('publishing'),
					z.literal('active'),
					z.literal('completed'),
				]),
				createdAt: z.iso.datetime(),
				location: z.string().nullable(),
				targetedAreas: z.array(
					z.object({
						id: z.string(),
						name: z.string(),
						countryName: z.string(),
						regionName: z.string().nullable(),
					}),
				),
				startDate: z.iso.datetime().nullable(),
				endDate: z.iso.datetime().nullable(),
				isEvergreen: z.boolean(),
				funnel: z.object({ views: z.number(), clicks: z.number(), candidates: z.number() }),
				scoreBands: z.object({
					bad: z.number(),
					good: z.number(),
					excellent: z.number(),
					unscored: z.number(),
				}),
				pipeline: z.object({ new: z.number(), other: z.number(), hired: z.number(), rejected: z.number() }),
				budget: z.number(),
				costPerCandidate: z.number().nullable(),
			}),
		),
		meta: z.object({ currentPage: z.number(), lastPage: z.number(), perPage: z.number(), total: z.number() }),
	}),
})

export type AnalyticsOverviewDataSchema = z.infer<typeof analyticsOverviewDataSchema>
